import type {Result, UseCase} from 'framework';
import type {KeepScreenAwakePreference} from '../../domain/keep-screen-awake-preference.value-object';
import type {KeepScreenAwakePreferenceRepository} from '../ports/keep-screen-awake-preference.repository';

export class SetKeepScreenAwakePreference implements UseCase<[KeepScreenAwakePreference], void> {
  constructor(private readonly repository: KeepScreenAwakePreferenceRepository) {}

  execute(preference: KeepScreenAwakePreference): Promise<Result<void>> {
    return this.repository.set(preference);
  }
}
